import instance from 'utils/axios/instance.axios';
import { REGISTER_RESULT } from './_constant';

export const createRegisterResult = (body = {}) =>
  instance.post(REGISTER_RESULT.CREATE_REGISTER_RESULT, body);

export const updateRegisterResult = (id, data) =>
  instance.patch(REGISTER_RESULT.UPDATE_REGISTER_RESULT(id), data);

export const submitRegisterResult = (registerResultId) =>
  instance.patch(REGISTER_RESULT.SUBMIT_REGISTER_RESULT(registerResultId));

export const createRegisterResultProduct = ({ registerResultId, body = {} }) =>
  instance.post(REGISTER_RESULT.CREATE_PRODUCT(registerResultId), body);

export const updateRegisterResultProduct = ({ registerResultId, productId, body = {} }) =>
  instance.patch(REGISTER_RESULT.UPDATE_PRODUCT(registerResultId, productId), body);

export const deleteRegisterResultProduct = ({ registerResultId, productId }) =>
  instance.delete(REGISTER_RESULT.DELETE_PRODUCT(registerResultId, productId));

export const createRegisterResultMinute = ({ registerResultId, body = {} }) =>
  instance.post(REGISTER_RESULT.CREATE_MINUTE(registerResultId), body);

export const createRegisterResultAppendix = ({ registerResultId, body = {} }) =>
  instance.post(REGISTER_RESULT.CREATE_APPENDIX(registerResultId), body);

export const deleteRegisterResultAppendix = ({ registerResultId, appendixId }) =>
  instance.delete(REGISTER_RESULT.DELETE_APPENDIX(registerResultId, appendixId));

export const getRegisterResult = (projectId) =>
  instance.get(REGISTER_RESULT.GET_REGISTER_RESULT_BY_PROJECT_ID(projectId));

export const getInspectionResult = (registerResultId) =>
  instance.get(REGISTER_RESULT.GET_INSPECTION_RESULT, { params: { projectId: registerResultId } });

export const getRegisterResultReviews = (registerResultId) =>
  instance.get(REGISTER_RESULT.GET_REVIEWS(registerResultId));

export const getRegisterResultReviewHistories = (registerResultId) =>
  instance.get(REGISTER_RESULT.GET_REVIEW_HISTORIES(registerResultId));

export const downloadRegisterResultFileUpload = (registerResultId, filename, type) =>
  instance.get(REGISTER_RESULT.GET_FILES(registerResultId), {
    params: { filename, type },
    responseType: 'blob',
  });

export const sendReviewFeedback = ({ registerResultId, reviewId, body = {} }) =>
  instance.patch(REGISTER_RESULT.REVIEW_FEEDBACK(registerResultId, reviewId), body);

export const downloadRegisterResultDocxTemplate = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_DOCX_TEMPLATE, body, { responseType: 'blob' });

export const downloadRegisterResultDocxFile = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_DOCX_FILE, body, { responseType: 'blob' });

export const downloadRegisterResultPdfTemplate = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_PDF_TEMPLATE, body, { responseType: 'blob' });

export const downloadRegisterResultPdfFile = (body) =>
  instance.post(REGISTER_RESULT.DOWNLOAD_PDF_FILE, body, { responseType: 'blob' });
